import React from "react";
import LeagMainHead from "../../common/LeagMainHead";
import GolfInfoWrapper from "../../golf/GolfInfoWrapper";
import News from "../../common/News";

const GolfLeagueWidgetWrap = (props) => {
  const {
    dataId,
    dataType,
    head,
    data,
    headData,
    baseUrl,
    sport,
    difference,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,
    setDataType,
    setDataId,
    setHead,
  } = props;



  const renderHeadWrap = (currentTab, children) =>
    head ? (
      <LeagMainHead
        id={dataId}
        headData={headData}
        baseUrl={baseUrl}
        sport={"golf"}
        dataClient={dataClient}
        currentTab={currentTab}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        widgetTitle={dataTitle}
      >
        {children}
      </LeagMainHead>
    ) : (
      children
    );

  switch (dataType) {
    case "golf-league-info":
      return renderHeadWrap("info",
        <GolfInfoWrapper
          id={dataId}
          sport={sport}
          data={data?.data}
          loadCSS={loadCSS}
          baseUrl={baseUrl}
          setDataType={setDataType}
          setDataId={setDataId}
          setHead={setHead}
          dataClient={dataClient}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          difference={difference}
        />
      );

    case "golf-league-news":
      return renderHeadWrap("info",
        <News
          id={dataId}
          sport={sport}
          data={data}
          loadCSS={loadCSS}
          baseUrl={baseUrl}
          setDataType={setDataType}
          setDataId={setDataId}
          setHead={setHead}
          dataClient={dataClient}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          difference={difference}
        />
      );


    default:
      return <h1>golf League Widget Not Found!</h1>;
  }
};

export default GolfLeagueWidgetWrap;
